const perspectiveTypes = {
    FRONT_1D: 1,
    FRONT_2D: 2,
    RIGHT_2D: 3,
    LEFT_2D: 4,
    LEFT_3D: 5,
    RIGHT_3D: 6,
    FRONT_3D: 7,
}

// ----------------------------------------------
// Point.js
// ----------------------------------------------

var ImgWarper = ImgWarper || {}

ImgWarper.Point = function (x, y) {
    this.x = x
    this.y = y
}

ImgWarper.Point.prototype.add = function (o) {
    return new ImgWarper.Point(this.x + o.x, this.y + o.y)
}

ImgWarper.Point.prototype.subtract = function (o) {
    return new ImgWarper.Point(this.x - o.x, this.y - o.y)
}

// w * [x; y] * [x, y]
ImgWarper.Point.prototype.wXtX = function (w) {
    return new ImgWarper.Matrix22(
        this.x * this.x * w,
        this.x * this.y * w,
        this.y * this.x * w,
        this.y * this.y * w
    )
}

// Dot product
ImgWarper.Point.prototype.dotP = function (o) {
    return this.x * o.x + this.y * o.y
}

ImgWarper.Point.prototype.multiply = function (o) {
    return new ImgWarper.Point(
        this.x * o.M11 + this.y * o.M21,
        this.x * o.M12 + this.y * o.M22
    )
}

ImgWarper.Point.prototype.multiply_d = function (o) {
    return new ImgWarper.Point(this.x * o, this.y * o)
}

ImgWarper.Point.weightedAverage = function (p, w) {
    var i
    var sx = 0,
        sy = 0,
        sw = 0

    for (i = 0; i < p.length; i++) {
        sx += p[i].x * w[i]
        sy += p[i].y * w[i]
        sw += w[i]
    }
    return new ImgWarper.Point(sx / sw, sy / sw)
}

ImgWarper.Point.prototype.InfintyNormDistanceTo = function (o) {
    return Math.max(Math.abs(this.x - o.x), Math.abs(this.y - o.y))
}

// ----------------------------------------------
// matrix22.js
// ----------------------------------------------

ImgWarper.Matrix22 = function (N11, N12, N21, N22) {
    this.M11 = N11
    this.M12 = N12
    this.M21 = N21
    this.M22 = N22
}

ImgWarper.Matrix22.prototype.adjugate = function () {
    return new ImgWarper.Matrix22(this.M22, -this.M12, -this.M21, this.M11)
}

ImgWarper.Matrix22.prototype.determinant = function () {
    return this.M11 * this.M22 - this.M12 * this.M21
}

ImgWarper.Matrix22.prototype.multiply = function (m) {
    this.M11 *= m
    this.M12 *= m
    this.M21 *= m
    this.M22 *= m
    return this
}

ImgWarper.Matrix22.prototype.addM = function (o) {
    this.M11 += o.M11
    this.M12 += o.M12
    this.M21 += o.M21
    this.M22 += o.M22
}

ImgWarper.Matrix22.prototype.inverse = function () {
    return this.adjugate().multiply(1.0 / this.determinant())
}

// ----------------------------------------------
// deformation.js
// ----------------------------------------------

var ImgWarper = ImgWarper || {}

ImgWarper.Warper = function (canvas, img, imgData, optGridSize, optAlpha) {
    this.alpha = optAlpha || 1
    this.gridSize = optGridSize || 20
    this.canvas = canvas
    this.ctx = canvas.getContext('2d')

    var source = img
    this.width = source.width
    this.height = source.height
    this.imgData = imgData.data
    this.canvas.width = img.width
    this.canvas.height = img.height
    this.bilinearInterpolation = new ImgWarper.BilinearInterpolation(
        this.width,
        this.height,
        canvas
    )

    this.ctx.setTransform(1, 0, 0, 1, 0, 0)
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this.ctx.putImageData(imgData, 0, 0)

    this.grid = []
    for (var i = 0; i < this.width; i += this.gridSize) {
        for (var j = 0; j < this.height; j += this.gridSize) {
            var a = new ImgWarper.Point(i, j)
            var b = new ImgWarper.Point(i + this.gridSize, j)
            var c = new ImgWarper.Point(i + this.gridSize, j + this.gridSize)
            var d = new ImgWarper.Point(i, j + this.gridSize)
            this.grid.push([a, b, c, d])
        }
    }
}

ImgWarper.Warper.prototype.warp = function (fromPoints, toPoints) {
    var t0 = new Date().getTime()
    var deformation = new ImgWarper.AffineDeformation(
        toPoints,
        fromPoints,
        this.alpha
    )
    var transformedGrid = []
    for (var i = 0; i < this.grid.length; ++i) {
        transformedGrid[i] = [
            deformation.pointMover(this.grid[i][0]),
            deformation.pointMover(this.grid[i][1]),
            deformation.pointMover(this.grid[i][2]),
            deformation.pointMover(this.grid[i][3]),
        ]
    }
    var t1 = new Date().getTime()
    var newImg = this.bilinearInterpolation.generate(
        this.imgData,
        this.grid,
        transformedGrid
    )
    this.ctx.setTransform(1, 0, 0, 1, 0, 0)
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this.ctx.putImageData(newImg, 0, 0)

    var t2 = new Date().getTime()
}

ImgWarper.Warper.prototype.drawGrid = function (fromPoints, toPoints) {
    // Forward warping.
    var deformation = new ImgWarper.AffineDeformation(
        fromPoints,
        toPoints,
        this.alpha
    )
    var context = this.canvas.getContext('2d')
    for (var i = 0; i < this.grid.length; ++i) {
        context.beginPath()
        var point = deformation.pointMover(this.grid[i][0])
        context.moveTo(point.x, point.y)
        for (var j = 1; j < 4; ++j) {
            point = deformation.pointMover(this.grid[i][j])
            context.lineTo(point.x, point.y)
        }
        context.strokeStyle = 'rgba(170, 170, 170, 0.5)'
        context.stroke()
    }
}

ImgWarper.AffineDeformation = function (fromPoints, toPoints, alpha) {
    this.w = null
    this.pRelative = null
    this.qRelative = null
    this.A = null
    if (fromPoints.length != toPoints.length) {
        console.error('Points are not of same length.')
        return
    }
    this.n = fromPoints.length
    this.fromPoints = fromPoints
    this.toPoints = toPoints
    this.alpha = alpha
}
ImgWarper.AffineDeformation.prototype.pointMover = function (point) {
    if (null == this.pRelative || this.pRelative.length < this.n) {
        this.pRelative = new Array(this.n)
    }
    if (null == this.qRelative || this.qRelative.length < this.n) {
        this.qRelative = new Array(this.n)
    }
    if (null == this.w || this.w.length < this.n) {
        this.w = new Array(this.n)
    }
    if (null == this.A || this.A.length < this.n) {
        this.A = new Array(this.n)
    }

    for (var i = 0; i < this.n; ++i) {
        var t = this.fromPoints[i].subtract(point)
        this.w[i] = Math.pow(t.x * t.x + t.y * t.y, -this.alpha)
    }

    var pAverage = ImgWarper.Point.weightedAverage(this.fromPoints, this.w)
    var qAverage = ImgWarper.Point.weightedAverage(this.toPoints, this.w)

    for (var i = 0; i < this.n; ++i) {
        this.pRelative[i] = this.fromPoints[i].subtract(pAverage)
        this.qRelative[i] = this.toPoints[i].subtract(qAverage)
    }

    var B = new ImgWarper.Matrix22(0, 0, 0, 0)

    for (var i = 0; i < this.n; ++i) {
        B.addM(this.pRelative[i].wXtX(this.w[i]))
    }

    B = B.inverse()
    for (var j = 0; j < this.n; ++j) {
        this.A[j] =
            point.subtract(pAverage).multiply(B).dotP(this.pRelative[j]) *
            this.w[j]
    }

    var r = qAverage //r is an point
    for (var j = 0; j < this.n; ++j) {
        r = r.add(this.qRelative[j].multiply_d(this.A[j]))
    }
    return r
}

// ----------------------------------------------
// interpolation.js
// ----------------------------------------------
var ImgWarper = ImgWarper || {}

ImgWarper.BilinearInterpolation = function (width, height, canvas) {
    this.width = width
    this.height = height
    this.ctx = canvas.getContext('2d')
    this.imgTargetData = this.ctx.createImageData(this.width, this.height)
}

ImgWarper.BilinearInterpolation.prototype.generate = function (
    source,
    fromGrid,
    toGrid
) {
    this.imgData = source
    for (var i = 0; i < toGrid.length; ++i) {
        this.fill(toGrid[i], fromGrid[i])
    }
    return this.imgTargetData
}

ImgWarper.BilinearInterpolation.prototype.fill = function (
    sourcePoints,
    fillingPoints
) {
    var i, j
    var srcX, srcY
    var x0 = fillingPoints[0].x
    var x1 = fillingPoints[2].x
    var y0 = fillingPoints[0].y
    var y1 = fillingPoints[2].y
    x0 = Math.max(x0, 0)
    y0 = Math.max(y0, 0)
    x1 = Math.min(x1, this.width - 1)
    y1 = Math.min(y1, this.height - 1)

    var xl, xr, topX, topY, bottomX, bottomY
    var yl, yr, rgb, index

    for (i = x0; i <= x1; ++i) {
        xl = (i - x0) / (x1 - x0)
        xr = 1 - xl
        topX = xr * sourcePoints[0].x + xl * sourcePoints[1].x
        topY = xr * sourcePoints[0].y + xl * sourcePoints[1].y
        bottomX = xr * sourcePoints[3].x + xl * sourcePoints[2].x
        bottomY = xr * sourcePoints[3].y + xl * sourcePoints[2].y
        for (j = y0; j <= y1; ++j) {
            yl = (j - y0) / (y1 - y0)
            yr = 1 - yl
            srcX = topX * yr + bottomX * yl
            srcY = topY * yr + bottomY * yl
            index = (j * this.width + i) * 4
            if (
                srcX < 0 ||
                srcX > this.width - 1 ||
                srcY < 0 ||
                srcY > this.height - 1
            ) {
                this.imgTargetData.data[index] = 255
                this.imgTargetData.data[index + 1] = 255
                this.imgTargetData.data[index + 2] = 255
                this.imgTargetData.data[index + 3] = 0.5
                continue
            }
            var srcX1 = Math.floor(srcX)
            var srcY1 = Math.floor(srcY)
            var base = (srcY1 * this.width + srcX1) * 4
            // rgb = this.nnquery(srcX, srcY);
            this.imgTargetData.data[index] = this.imgData[base]
            this.imgTargetData.data[index + 1] = this.imgData[base + 1]
            this.imgTargetData.data[index + 2] = this.imgData[base + 2]
            this.imgTargetData.data[index + 3] = this.imgData[base + 3]
        }
    }
}

ImgWarper.BilinearInterpolation.prototype.nnquery = function (x, y) {
    var x1 = Math.floor(x)
    var y1 = Math.floor(y)
    var base = (y1 * this.width + x1) * 4
    return [
        this.imgData[base],
        this.imgData[base + 1],
        this.imgData[base + 2],
        this.imgData[base + 3],
    ]
}

ImgWarper.BilinearInterpolation.prototype.query = function (x, y) {
    var x1, x2, y1, y2
    x1 = Math.floor(x)
    x2 = Math.ceil(x)
    y1 = Math.floor(y)
    y2 = Math.ceil(y)

    var c = [0, 0, 0, 0] // get new RGB

    var base11 = (y1 * this.width + x1) * 4
    var base12 = (y2 * this.width + x1) * 4
    var base21 = (y1 * this.width + x2) * 4
    var base22 = (y2 * this.width + x2) * 4
    // 4 channels: RGBA
    for (var i = 0; i < 4; ++i) {
        var t11 = this.imgData[base11 + i]
        var t12 = this.imgData[base12 + i]
        var t21 = this.imgData[base21 + i]
        var t22 = this.imgData[base22 + i]
        var t =
            (t11 * (x2 - x) * (y2 - y) +
                t21 * (x - x1) * (y2 - y) +
                t12 * (x2 - x) * (y - y1) +
                t22 * (x - x1) * (y - y1)) /
            ((x2 - x1) * (y2 - y1))
        c[i] = parseInt(t)
    }
    return c
}

// ----------------------------------------------
// point_definer.js
// ----------------------------------------------

var ImgWarper = ImgWarper || {}

ImgWarper.PointDefiner = function (
    canvas,
    image,
    imgData,
    optGridSize,
    optAlpha,
    oriPoints,
    dstPoints
) {
    this.oriPoints = oriPoints ?? new Array()
    this.dstPoints = dstPoints ?? new Array()

    //set up points for change;
    var c = canvas
    this.canvas = canvas
    var that = this
    this.dragging_ = false
    this.computing_ = false
    this.currentPointIndex = -1
    this.imgWarper = new ImgWarper.Warper(
        c,
        image,
        imgData,
        optGridSize,
        optAlpha
    )
}

ImgWarper.PointDefiner.prototype.redraw = function () {
    this.imgWarper.warp(this.oriPoints, this.dstPoints)
}

ImgWarper.PointDefiner.prototype.addPoints = function (
    originalPoint,
    destinationPoint
) {
    this.dragging_ = true

    var original = new ImgWarper.Point(originalPoint.x, originalPoint.y)
    this.oriPoints.push(original)

    var destination = new ImgWarper.Point(
        destinationPoint.x,
        destinationPoint.y
    )
    this.dstPoints.push(destination)

    this.currentPointIndex = this.getCurrentPointIndex(original)
    this.redraw()
}

ImgWarper.PointDefiner.prototype.getCurrentPointIndex = function (q) {
    var currentPoint = -1

    for (var i = 0; i < this.dstPoints.length; i++) {
        if (this.dstPoints[i].InfintyNormDistanceTo(q) <= 20) {
            currentPoint = i
            return i
        }
    }
    return currentPoint
}

ImgWarper.PointDefiner.prototype.redrawCanvas = function (points) {
    var ctx = this.canvas.getContext('2d')
    for (var i = 0; i < this.oriPoints.length; i++) {
        if (i < this.dstPoints.length) {
            if (i == this.currentPointIndex) {
                this.drawOnePoint(this.dstPoints[i], ctx, 'orange')
            } else {
                this.drawOnePoint(this.dstPoints[i], ctx, '#6373CF')
            }

            ctx.beginPath()
            ctx.lineWidth = 3
            ctx.moveTo(this.oriPoints[i].x, this.oriPoints[i].y)
            ctx.lineTo(this.dstPoints[i].x, this.dstPoints[i].y)
            //ctx.strokeStyle = '#691C50';
            ctx.stroke()
        } else {
            this.drawOnePoint(this.oriPoints[i], ctx, '#119a21')
        }
    }
    ctx.stroke()
}

// ----------------------------------------------
// utility.js
// ----------------------------------------------

var calculatedWidthRatio
var calculatedHeightRatio
var ImgWarper = ImgWarper || {}

const calcWidthRatio = (points, planesNumber) => {
    if (planesNumber === Planes.Three) {
        let upPoint = points.find(
            (q) =>
                q.faces.includes(Faces.Up) &&
                !q.faces.includes(Faces.Left) &&
                !q.faces.includes(Faces.Right)
        )
        let leftUpPoint = points.find(
            (q) => q.faces.includes(Faces.Left) && q.faces.includes(Faces.Up)
        )
        let leftBottomPoint = points.find(
            (q) =>
                q.faces.includes(Faces.Left) &&
                !q.faces.includes(Faces.Up) &&
                !q.faces.includes(Faces.Right)
        )

        let leftDistance = distancePoint(leftBottomPoint, leftUpPoint)
        let upDistance = distancePoint(leftUpPoint, upPoint)
        return (calculatedWidthRatio = upDistance / (leftDistance + upDistance))
    }

    return null
}

const calcHeightRatio = (points, planesNumber) => {
    if (planesNumber === Planes.Three) {
        let upPoint = points.find(
            (q) =>
                q.faces.includes(Faces.Up) &&
                !q.faces.includes(Faces.Left) &&
                !q.faces.includes(Faces.Right)
        )
        let rightUpPoint = points.find(
            (q) => q.faces.includes(Faces.Right) && q.faces.includes(Faces.Up)
        )
        let rightBottomPoint = points.find(
            (q) =>
                q.faces.includes(Faces.Right) &&
                !q.faces.includes(Faces.Up) &&
                !q.faces.includes(Faces.Left)
        )

        let rightDistance = distancePoint(rightBottomPoint, rightUpPoint)
        let upDistance = distancePoint(rightUpPoint, upPoint)
        return (calculatedHeightRatio =
            upDistance / (rightDistance + upDistance))
    } else if (planesNumber === Planes.Two) {
        let upRightPoint = points.find((q) => q.index === 2)
        let middleRightPoint = points.find((q) => q.index === 4)
        let bottomRightPoint = points.find((q) => q.index === 6)
        let rightDistance = distancePoint(middleRightPoint, bottomRightPoint)
        let upDistance = distancePoint(upRightPoint, middleRightPoint)

        return (calculatedHeightRatio =
            upDistance / (rightDistance + upDistance))
    }
    return null
}

const defaultOriginalPoints = (
    backgroundImgWidth,
    backgroundImgHeight,
    widthRatio,
    heightRatio,
    planesNumber,
    margin = 0
) => {
    let result = []

    const xMin = 0 + margin
    const xMax = backgroundImgWidth - margin
    const xMid = backgroundImgWidth * widthRatio

    const yMin = 0 + margin
    const yMax = backgroundImgHeight - margin
    const yMid = backgroundImgHeight * heightRatio

    result.push(
        ...[
            { index: 0, x: xMin, y: yMin },
            { index: 2, x: xMax, y: yMin },
            { index: 5, x: xMin, y: yMax },
            { index: 6, x: xMax, y: yMax },
        ]
    )

    switch (planesNumber) {
        case Planes.One:
            {
                result.push(
                    ...[
                        { index: 7, x: (xMax + xMin) / 2, y: yMin },
                        { index: 8, x: xMin, y: (yMin + yMax) / 2 },
                        { index: 9, x: xMax, y: (yMin + yMax) / 2 },
                        { index: 10, x: (xMax + xMin) / 2, y: yMax },
                    ]
                )
            }
            break
        case Planes.Two:
            result.push(
                ...[
                    { index: 3, x: xMin, y: yMid },
                    { index: 4, x: xMax, y: yMid },
                    // { index: 7, x: xMin, y: (yMin + yMid) / 2 },
                    // { index: 8, x: xMax, y: (yMin + yMid) / 2 },
                    // { index: 9, x: xMin, y: (yMid + yMax) / 2 },
                    // { index: 10, x: xMax, y: (yMid + yMax) / 2 },

                    { index: 11, x: (xMin + xMax) / 2, y: yMid },
                    // { index: 12, x: xMin + ((xMax - xMin) * 2) / 5, y: yMid },
                    // { index: 13, x: xMin + ((xMax - xMin) * 3) / 5, y: yMid },
                    // { index: 14, x: xMin + ((xMax - xMin) * 4) / 5, y: yMid },

                    { index: 15, x: (xMin + xMax) / 2, y: yMax },
                    { index: 16, x: (xMin + xMax) / 2, y: yMin },
                ]
            )
            break
        case Planes.Three:
            result.push(
                ...[
                    { index: 1, x: xMid, y: yMin },
                    { index: 3, x: xMin, y: yMid },
                    { index: 4, x: xMid, y: yMid },
                ]
            )
            break

        default:
            break
    }

    if (planesNumber === Planes.Three) {
        const xMidMid = widthRatio > 0.5 ? (xMin + xMid) / 2 : (xMax + xMid) / 2
        const yMidMid =
            heightRatio > 0.5 ? (yMin + yMid) / 2 : (yMax + yMid) / 2

        result.push(
            ...[
                { index: 7, x: xMidMid, y: yMin },
                { index: 8, x: xMin, y: yMidMid },
                {
                    index: 9,
                    x: xMid,
                    y: yMidMid,
                },
                {
                    index: 10,
                    x: xMax,
                    y: yMidMid,
                },
                {
                    index: 11,
                    x: xMidMid,
                    y: yMid,
                },
                {
                    index: 12,
                    x: xMidMid,
                    y: yMax,
                },
            ]
        )
    }

    return result
}

const getFinalPoints = (
    destinationPoints,
    planesNumber,
    defaultOriginalPoints,
    usingSevenPoints = true,
    interpolateMiddles = false,
    interpolate2D = true,
    perspectiveType
) => {
    let originalPoints = []

    if (planesNumber === Planes.Two && interpolate2D)
        cleanDestinationPoints(destinationPoints)
    destinationPoints.forEach((destinationPoint) => {
        if (destinationPoint.isMain) {
            originalPoints.push(
                defaultOriginalPoints.find(
                    (q) => q.index === destinationPoint.index
                )
            )
        } else if (usingSevenPoints) {
            destinationPoints = destinationPoints.filter(
                (q) => q.index != destinationPoint.index
            )
        }
    })

    if (interpolateMiddles) {
        const topMiddlePoint = getTopMiddlePoint(destinationPoints)
        destinationPoints.push(topMiddlePoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 7))

        const leftMiddlePoint = getLeftMiddlePoint(destinationPoints)
        destinationPoints.push(leftMiddlePoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 8))

        const rightMiddlePoint = getRightMiddlePoint(destinationPoints)
        destinationPoints.push(rightMiddlePoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 9))

        const bottomMiddlePoint = getBottomMiddlePoint(destinationPoints)
        destinationPoints.push(bottomMiddlePoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 11))

        const rightPoint = getRightPoint(destinationPoints)
        destinationPoints.push(rightPoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 10))

        const bottomPoint = getBottomPoint(destinationPoints)
        destinationPoints.push(bottomPoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 12))
    }

    if (planesNumber === Planes.Two && true) {
        for (let index = 1; index < 2; index++) {
            let fraction = 2
            if (
                perspectiveType == perspectiveTypes.RIGHT_2D ||
                perspectiveType == perspectiveTypes.RIGHT_3D
            )
                fraction = 2
            else if (
                perspectiveType == perspectiveTypes.LEFT_2D ||
                perspectiveType == perspectiveTypes.LEFT_3D
            )
                fraction = 3

            const point = getMiddlePoints2D(
                destinationPoints,
                fraction,
                perspectiveType
            )
            destinationPoints.push(point)
            originalPoints.push(
                defaultOriginalPoints.find((q) => q.index === 1 + 10)
            )
        }
        const middleBottomPoint = getBottomMiddlePoint2D(
            destinationPoints,
            perspectiveType
        )
        destinationPoints.push(middleBottomPoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 15))

        const middleTopPoint = getTopMiddlePoint(
            destinationPoints,
            perspectiveType
        )
        destinationPoints.push(middleTopPoint)
        originalPoints.push(defaultOriginalPoints.find((q) => q.index === 16))
    }

    let result = usingSevenPoints ? originalPoints : defaultOriginalPoints
    return { originalPoints: result, destinationPoints }
}

const cleanDestinationPoints = (destinationPoints) => {
    const limitInPixel = 0
    const margin = 0

    const point3 = getPointAt(destinationPoints, 3)
    const point5 = getPointAt(destinationPoints, 5)

    let distanceLeft = distancePoint(point3, point5)
    if (distanceLeft < limitInPixel) {
        const point = extrapolate(point3, point5, margin)
        point5.x = point.x
        point5.y = point.y
    }

    const point4 = getPointAt(destinationPoints, 4)
    const point6 = getPointAt(destinationPoints, 6)

    let distanceRight = distancePoint(point4, point6)
    if (distanceRight < limitInPixel) {
        const point = extrapolate(point4, point6, margin)
        point6.x = point.x
        point6.y = point.y
    }
}

const getMiddlePoints2D = (
    destinationPoints,
    fractionIndex,
    perspectiveType
) => {
    let leftIndex = 3
    let rightIndex = 4

    let average = averagePointAt(
        destinationPoints,
        leftIndex,
        rightIndex,
        5 / fractionIndex
    )

    return { index: fractionIndex + 10, x: average.x, y: average.y }
}

const getBottomMiddlePoint2D = (destinationPoints, perspectiveType) => {
    let leftIndex = 5
    let rightIndex = 6

    let average = averagePointAt(destinationPoints, leftIndex, rightIndex)

    let result = { index: 15, x: average.x, y: average.y }
    if (
        perspectiveType == perspectiveTypes.RIGHT_2D ||
        perspectiveType == perspectiveTypes.RIGHT_3D
    )
        result.x *= 2
    else if (
        perspectiveType == perspectiveTypes.LEFT_2D ||
        perspectiveType == perspectiveTypes.LEFT_3D
    )
        result.y *= 2

    return result
}

const getTopMiddlePoint = (destinationPoints, perspectiveType) => {
    // let leftIndex = calculatedWidthRatio > 0.5 ? 0 : 1;
    // let rightIndex = calculatedWidthRatio > 0.5 ? 1 : 2;

    let leftIndex = 0
    let rightIndex = 2

    if (
        perspectiveType == perspectiveTypes.RIGHT_2D ||
        perspectiveType == perspectiveTypes.RIGHT_3D
    ) {
        leftIndex = 3
        rightIndex = 0
    }

    let average = averagePointAt(destinationPoints, leftIndex, rightIndex)

    let result = { index: 16, x: average.x, y: average.y }
    if (
        perspectiveType == perspectiveTypes.RIGHT_2D ||
        perspectiveType == perspectiveTypes.RIGHT_3D
    ) {
        result.x *= 2
        result.y *= 0.5
    } else if (
        perspectiveType == perspectiveTypes.LEFT_2D ||
        perspectiveType == perspectiveTypes.LEFT_3D
    ) {
        result.x *= 0.5
        result.y *= 2
    }

    return result
    // return { index: 7, x: average.x * 1.5, y: average.y * 0.5 };
}

const getLeftMiddlePoint = (destinationPoints) => {
    let topIndex = calculatedHeightRatio > 0.5 ? 0 : 3
    let bottomIndex = calculatedHeightRatio > 0.5 ? 3 : 5

    let average = averagePointAt(destinationPoints, topIndex, bottomIndex)

    return { index: 8, x: average.x, y: average.y }
}

const getRightMiddlePoint = (destinationPoints) => {
    let topIndex = calculatedHeightRatio > 0.5 ? 1 : 4
    let bottomIndex = calculatedHeightRatio > 0.5 ? 4 : 6

    let average = averagePointAt(destinationPoints, topIndex, bottomIndex)

    return { index: 9, x: average.x, y: average.y }
}

const getBottomMiddlePoint = (destinationPoints) => {
    let leftIndex = calculatedHeightRatio > 0.5 ? 3 : 4
    let rightIndex = calculatedHeightRatio > 0.5 ? 4 : 5

    let average = averagePointAt(destinationPoints, leftIndex, rightIndex)

    return { index: 11, x: average.x, y: average.y }
}

const getRightPoint = (destinationPoints) => {
    let topIndex = 2
    let bottomIndex = 6

    let average = averagePointAt(destinationPoints, bottomIndex, topIndex)

    return { index: 11, x: average.x, y: average.y }
}

const getBottomPoint = (destinationPoints) => {
    let leftIndex = 5
    let rightIndex = 6

    let average = averagePointAt(destinationPoints, leftIndex, rightIndex)

    return { index: 11, x: average.x, y: average.y }
}

const extrapolate = (point1, point2, distance) => {
    const vector = { x: point2.x - point1.x, y: point2.y - point1.y }
    const vectorDimension = distancePoint(vector, { x: 0, y: 0 })
    return {
        x: point1.x + (vector.x * distance) / vectorDimension,
        y: point1.y + (vector.y * distance) / vectorDimension,
    }
}

const averagePointAt = (destinationPoints, index1, index2, weight = 2) => {
    let point1 = getPointAt(destinationPoints, index1)
    let point2 = getPointAt(destinationPoints, index2)
    return averagePoint(point1, point2, weight)
}

const averagePoint = (point1, point2, weight) => {
    return {
        x: point1.x - (point1.x - point2.x) / weight,
        y: point1.y - (point1.y - point2.y) / weight,
    }
}

const distancePoint = (point1, point2) => {
    return Math.sqrt(
        (point2.y - point1.y) * (point2.y - point1.y) +
            (point2.x - point1.x) * (point2.x - point1.x)
    )
}

const getPointAt = (destinationPoints, index) => {
    return destinationPoints.find((q) => q.index === index)
}

const screenshot = (e) => {
    let canvas = document.getElementById('main-canvas')
    let src = canvas.toDataURL('image/jpeg', 0.5)
    scaleImage(src, 1)
}

const scaleImage = (mainCanvas, src, scale, callBack) => {
    let image = new Image()
    image.crossOrigin = 'Anonymous'
    image.onload = function () {
        let canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d')

        let width = mainCanvas.width
        let height = mainCanvas.height

        canvas.width = width * scale
        canvas.height = height * scale

        ctx.drawImage(
            this,
            ((1 - scale) * width) / 2,
            ((1 - scale) * height) / 2,
            width * scale,
            height * scale
        )
        let result = canvas.toDataURL('image/jpeg', 0.5)
        callBack(result)
    }
    image.src = src
    return src
}

const createMainCanvas = () => {
    let result = document.createElement('canvas')
    result.id = 'main-canvas'
    result.style.backgroundRepeat = 'no-repeat'
    result.style.backgroundSize = 'contain'
    result.style.backgroundPosition = 'center'
    result.style.margin = '0'
    result.style.display = 'none'

    return result
}

const createHelperCanvas = () => {
    let result = document.createElement('canvas')
    result.id = 'my-canvas'
    result.style.display = 'none'
    return result
}

const createRepeatImageCanvas = (width, height, textureScale) => {
    let result = document.createElement('canvas')
    result.id = 'repeat-image-canvas'
    result.width = width * textureScale
    result.height = height * textureScale
    result.style.backgroundRepeat = 'no-repeat'
    result.style.backgroundSize = 'contain'
    result.style.backgroundPosition = 'center'
    result.style.margin = '0'
    result.style.display = 'none'

    return result
}

function repeatImage(imgUrl, imgWidth, imgHeight, textureScale, callback) {
    var canvas = createRepeatImageCanvas(imgWidth, imgHeight, textureScale),
        context = canvas.getContext('2d'),
        img = new Image()
    img.crossOrigin = 'Anonymous'

    img.onload = function () {
        // create pattern
        var ptrn = context.createPattern(img, 'repeat') // Create a pattern with this image, and set it to "repeat".
        context.fillStyle = ptrn
        context.fillRect(0, 0, canvas.width, canvas.height) // context.fillRect(x, y, width, height);
        callback(canvas.toDataURL())
    }

    img.src = imgUrl

    return img
}

const Faces = { Up: 'Up', Right: 'Right', Left: 'Left' }
const Planes = { One: '1', Two: '2', Three: '3' }

// ----------------------------------------------
// main.js
// ----------------------------------------------
export const drawPerspective = (
    points,
    textureUrl,
    imgWidth,
    imgHeight,
    planesNumber,
    resultCallBack,
    gridSize = 10,
    marginInPixel,
    textureScale = 1,
    perspectiveType
) => {
    repeatImage(
        textureUrl,
        imgWidth,
        imgHeight,
        textureScale,
        function (imgSrc) {
            loadTexture(
                imgSrc,
                points,
                imgWidth,
                imgHeight,
                planesNumber,
                resultCallBack,
                gridSize,
                marginInPixel,
                perspectiveType
            )
        }
    )
}

const loadTexture = (
    url,
    destinationPoints,
    backgroundImgWidth,
    backgroundImgHeight,
    planesNumber,
    callBack,
    gridSize,
    marginInPixel,
    perspectiveType
) => {
    var canvas = createMainCanvas()
    var warper = null

    var img = render(
        url,
        function (imageData) {
            const widthRatio =
                planesNumber === Planes.One
                    ? null
                    : calcWidthRatio(destinationPoints, planesNumber)
            const heightRatio =
                planesNumber === Planes.One
                    ? null
                    : calcHeightRatio(destinationPoints, planesNumber)

            let originalPoints = defaultOriginalPoints(
                backgroundImgWidth,
                backgroundImgHeight,
                widthRatio,
                heightRatio,
                planesNumber,
                marginInPixel
            )

            let convertedPoints = getFinalPoints(
                destinationPoints,
                planesNumber,
                originalPoints,
                true,
                false,
                false,
                perspectiveType
            )

            warper = new ImgWarper.PointDefiner(
                canvas,
                img,
                imageData,
                gridSize
                // 0.5
            )

            for (
                let index = 0;
                index < convertedPoints.destinationPoints.length;
                index++
            ) {
                warper.addPoints(
                    convertedPoints.originalPoints[index],
                    convertedPoints.destinationPoints[index]
                )
            }

            let src = canvas.toDataURL('image/jpeg', 0.5)
            scaleImage(canvas, src, 1, callBack)
        },
        backgroundImgWidth,
        backgroundImgHeight
    )
}

function render(src, callback, backgroundImgWidth, backgroundImgHeight) {
    var image = new Image()
    image.crossOrigin = 'Anonymous'

    image.onload = function () {
        var canvas = createHelperCanvas()
        var ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        image.width = backgroundImgWidth
        image.height = backgroundImgHeight
        canvas.width = backgroundImgWidth
        canvas.height = backgroundImgHeight

        ctx.drawImage(image, 0, 0, image.width, image.height)
        callback(ctx.getImageData(0, 0, image.width, image.height))
    }
    image.src = src
    return image
}
